import { Directive, inject, OnInit } from '@angular/core';
import { AbstractCustomerComponent } from '@df/account/v2/abstract-customer.component';
import { CustomerLoggedGuard } from '@df/session/customer/customer-logged.guard';

@Directive()
export abstract class AccountV2ViewComponentDef extends AbstractCustomerComponent implements OnInit {
    protected customerLoggedGuard = inject(CustomerLoggedGuard);

    /**
     * On init hook to set up status changes listener
     */
    override ngOnInit() {
        this.subscriptions.add(
            this.customer.model.obs.status.subscribe(() => {
                if (!this.customerLoggedGuard.isCustomerAllowed()) {
                    this.customerLoggedGuard.onError();
                }
            })
        );
        
        super.ngOnInit();
    }
}
